export default class ImagesModel {
  public main: string | null = null;
  public cover: string | null = null;
  public mobile: string | null = null;
}
